
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzle/[id]",
      function () {
        return require("private-next-pages/puzzle/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzle/[id]"])
      });
    }
  